import { useEffect, useRef, useState } from "react";
import { Img } from "@/components/blocks/Parts";
import { Reveal } from "./Reveal";

const STEP = 9;

const Photo = ({ src, onOpen, idx }) => (
  <button
    onClick={() => onOpen(idx)}
    className="block w-full overflow-hidden img-zoom cursor-zoom-in mb-4 sm:mb-8"
    data-testid={`gallery-photo-${idx}`}
  >
    <Img src={src} alt="" eager={idx < 3} className="w-full h-auto block" />
  </button>
);

export const NarrativeGallery = ({ photos, offset = 0, onOpen }) => {
  const [shown, setShown] = useState(Math.min(STEP, photos.length));
  const sentinel = useRef(null);

  useEffect(() => {
    if (shown >= photos.length || !sentinel.current) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setShown((s) => Math.min(s + STEP, photos.length));
    }, { rootMargin: "600px" });
    io.observe(sentinel.current);
    return () => io.disconnect();
  }, [shown, photos.length]);

  return (
    <Reveal>
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 sm:gap-8" data-testid="gallery-masonry">
        {photos.slice(0, shown).map((p, k) => (
          <div key={`${p}-${k}`} className="break-inside-avoid">
            <Photo src={p} idx={offset + k} onOpen={onOpen} />
          </div>
        ))}
      </div>
      {shown < photos.length && <div ref={sentinel} className="h-8" aria-hidden />}
    </Reveal>
  );
};
